export default __webpack_public_path__ + "static/media/AR-12.2d2da61b.jpg";